{
  "ONIS": {
    "key": "onis",
    "contract_address": "0x0ee7Bf57733e3DA8C015a0E7E395d641FAC512d6",
    "contract_name": null,
    "max_supply": ["1...6666"],
    "first_id": 1
  },
  "LAZY_LIONS": {
    "key": "lions",
    "contract_address": "0x8943c7bac1914c9a7aba750bf2b6b09fd21037e0",
    "contract_name": null,
    "max_supply": ["0...10000"],
    "first_id": 0
  },
  "CURIOUS_ADDYS": {
    "key": "addys",
    "contract_address": "0x82712d0052c6d8185383b5554a071c440b902992",
    "contract_name": null,
    "max_supply": ["1...4800","9801...10000"],
    "first_id": 1
  },
  "BABY_SPIRITS": {
    "key": "baby_spirits",
    "contract_address": "0xd5A22cB1EFA368c753b5b7a3879dAEB026e7B1f8",
    "contract_name": "BabySpirits",
    "max_supply": 0,
    "first_id": 1
  },
  "JUNGLE_FREAKS": {
    "key": "jungle_freaks",
    "contract_address": "0x7e6bc952d4b4bd814853301bee48e99891424de0",
    "contract_name": null,
    "max_supply": ["0...9999"],
    "first_id": 0
  }
}
